<!-- Custom template -->
@if (command()?.template != null) {
  <ng-template
    [ngTemplateOutlet]="command().template"
    [ngTemplateOutletContext]="{ entry: result(), group: group() }"
  ></ng-template>
} @else {
  <!-- Generic result -->
  @if (result().icon != null) {
    <i [class]="result().icon + ' fa-fw quick-command__result-icon'"></i>
  }
  @if (highlight()) {
    <span class="flex-grow-1" [innerHTML]="result().label | highlightText: query()"></span>
  } @else {
    <span class="flex-grow-1" [innerHTML]="result().label"></span>
  }

  @if (result().command?.hotkey != null) {
    @let parts = result().command.hotkey.split('.');

    <div class="quick-commands__hotkey">
      @for (part of parts; track part) {
        <kbd>
          @if ($last) {
            {{ part }}
          } @else {
            {{ 'common.keys.modifier.' + part | translate }}
          }
        </kbd>
      }
    </div>
  }

  @if (result().description != null) {
    <span
      class="quick-commands__result-description flex-grow-1"
      [innerHTML]="result().description | translate"
    ></span>
  }
}
